<template>
  <div class="promote">
    <el-button class="btn-right" type="primary" @click="onAddDialog" v-if="!isEdit">
      添加推广位
    </el-button>
    <div class="table-link" @click="onEditDialog" v-else>编辑</div>
    <el-dialog v-if="dialogVisible" :title="`${isEdit ? '编辑' : '新增'}推广位`" width="500px" :visible.sync="dialogVisible"
      modal-append-to-body append-to-body>
      <el-form label-width="100px" :model="form" :rules="rules" ref="form">
        <el-form-item label="推广位名称" prop="name">
          <el-input v-model="form.name" :maxlength="20" placeholder="请输入推广位名称"></el-input>
        </el-form-item>
        <el-form-item label="关联应用" prop="referMiniKey">
          <el-select :style="{ width: '100%' }" :disabled="isEdit" v-model="form.referMiniKey" placeholder="请选择关联应用">
            <el-option v-for="item in referMiniData" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广成本" prop="costPrice">
          <el-input v-model="form.costPrice" placeholder="请输入推广成本"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :maxlength="500" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注"
            v-model="form.remark"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="saveLoading" class="dialog-footer__button dialog-footer__sure" @click="onSure">确
          定</el-button>
        <el-button class="dialog-footer__button dialog-footer__cancel" @click="onCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mini from "@/api/mini";
const MiniModel = new mini()
import { matchInteger } from "@/utils/regExp";
const formParams = {
  name: "", // 推广位名称
  remark: "", //备注
  referMiniKey: "", // 关联小程序appkey
  costPrice: "", // 推广成本（单位元）
};
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },

    isEdit: {
      // 是否是编辑
      type: Boolean,
      default: false
    },
    referMiniData: { // 应用名
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: Object.assign({}, formParams),
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
      bankList: [], // 银行卡列表
      rules: {
        name: [{ required: true, message: "请输入推广位名称", trigger: "blur" }],
        referMiniKey: [
          {
            required: true,
            message: "请选择应用名",
            trigger: ["blur", "change"],
          },
        ],
        costPrice: [
          {
            required: false,
            pattern: matchInteger,
            message: "请输入正整数",
            trigger: ["blur", "change"],
          },
          {
            required: false,
            validator: (rule, value, callback) => {
              if (value > 99999999) {
                callback(new Error("请输入小于99999999的推广成本"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],

      },
    };
  },
  methods: {
    // 打开新增弹框
    onAddDialog() {
      this.dialogVisible = true;
    },
    // 打开编辑弹框
    onEditDialog() {

      this.form = {
        name: this.row.name,
        remark: this.row.remark,
        costPrice: this.row.costPriceYuan,
        referMiniKey: this.row.referMiniKey,
      };
      this.dialogVisible = true;
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.form = Object.assign({}, formParams);
      this.dialogVisible = false;
    },

    // 确定
    onSure() {
      if (this.isEdit) {
        this.saveLoading = true;
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            let params = {
              ...this.form,
              id: this.row.id
            }
            const data = await MiniModel.editPromote(params).finally(() => {
              this.saveLoading = false;
            });
            if (data.data.code === 200) {
              this.onCancel();
              this.$emit("refresh");
              this.$message.success(data.data.message);
            } else {
              this.$message.error(data.data.message);
            }
          } else {
            this.saveLoading = false;
          }
        });
      } else {
        this.saveLoading = true;
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            let params = {
              ...this.form,
            }
            const data = await MiniModel.addPromote(params).finally(() => {
              this.saveLoading = false;
            });
            if (data.data.code === 200) {
              this.onCancel();
              this.$emit("refresh");
              this.$message.success(data.data.message);
            } else {
              this.$message.error(data.data.message);
            }
          } else {
            this.saveLoading = false;
          }
        });
      }

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/promotionManage/PromoteCreate.vue